import { useStore } from 'effector-react'
import * as React from 'react'

import {
  $verificationCount,
  $verificationCountByMonth,
  getVerificationCount,
  verificationCountMounted,
} from './model'

export const useVerificationCountWidget = () => {
  React.useEffect(() => {
    verificationCountMounted()
  }, [])

  const verificationCount = useStore($verificationCount)
  const verificationCountByMonth = useStore($verificationCountByMonth)
  const loading = useStore(getVerificationCount.pending)

  return {
    verificationCount,
    verificationCountByMonth,
    loading,
  }
}
